import { Outlet, useNavigate, Link } from "react-router-dom";
import { Navbar, Container, Button } from "react-bootstrap";
import logo from "../../assets/LogoSolo.png";

const SocioLayout = () => {
    const navigate = useNavigate();

    const handleLogout = () => {
        localStorage.removeItem("token");
        navigate("/login/socio");
        window.location.reload();
    };

    return (
        <div style={{ backgroundColor: "#f8f9fa", minHeight: "100vh" }}>
            <Navbar bg="white" className="shadow-sm mb-4">

                <Container className="d-flex justify-content-between align-items-center">
                    <span className='logo'>
                        <img src={logo} alt="Kolping Chile Maestro de Socios" className='App-logo' />
                    </span>
                    <h5>Portal del Socio</h5>
                    <div className="d-flex align-items-center gap-2">
                        <Link to="/socio/cambiar-contraseña">
                            <Button variant="outline-primary" size="sm">
                                Cambiar contraseña
                            </Button>
                        </Link>
                        <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                            Cerrar sesión
                        </Button>
                    </div>
                </Container>
            </Navbar>

            <Container>
                <Outlet /> {/* Aquí se renderizan las vistas del socio */}
            </Container>
        </div>
    );
};

export default SocioLayout;
